// This file is automatically generated. Do not edit manually.

import { CatalogPartToSiteParams } from "src/api/generated/erp/parts/catalogPart/service/catalogPartToSiteParams";
import { PartView } from "src/api/generated/erp/db/types/tables/partView";
import { ErpUnit } from "src/api/generated/erp/db/types/tables/erpUnit";
import { ProductionLineView } from "src/api/generated/erp/db/types/tables/productionLineView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CopyCatalogPartToSitesFormApi {
	export async function getFormInitData(args: {
		siteIds: Array<number>;
	}): Promise<CopyCatalogPartToSitesFormApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPart/copyToSite/getFormInitData",
			method: "POST",
			data: {
				siteIds: args.siteIds,
			},
		});
		return response as CopyCatalogPartToSitesFormApi_FormInitData;
	}

	export async function savePartToSites(args: { parts: Array<CatalogPartToSiteParams> }): Promise<Array<number>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPart/copyToSite/savePartToSites",
			method: "POST",
			data: {
				parts: args.parts,
			},
		});
		return response as Array<number>;
	}

	export async function getExistingPartsOnSites(args: {
		siteIds: Array<number>;
		catalogPartIds: Array<number>;
	}): Promise<Array<PartView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPart/copyToSite/getExistingPartsOnSites",
			method: "POST",
			data: {
				siteIds: args.siteIds,
				catalogPartIds: args.catalogPartIds,
			},
		});
		return response as Array<PartView>;
	}
}

export interface CopyCatalogPartToSitesFormApi_FormInitData {
	erpUnits: Array<ErpUnit>;
	productionLineOptionsBySiteId: Record<number, Array<ProductionLineView>>;
}
